export type ContactDetailsRecord = Record<string, any>;

const firstPresent = (...values: any[]): string | null => {
  for (const value of values) {
    const text = String(value ?? '').trim();
    if (text) return text;
  }
  return null;
};

/** Keep the contact view independent of the payload's contact/user field shape. */
export const normalizeContactDetails = (contact: ContactDetailsRecord): ContactDetailsRecord => ({
  ...contact,
  email: firstPresent(contact.email, contact.email_address, contact.emailAddress),
  phone: firstPresent(contact.phone, contact.phone_number, contact.phoneNumber),
});

export const contactDetailRows = (contact: ContactDetailsRecord) => {
  const normalized = normalizeContactDetails(contact);
  const rows = [
    { label: 'Email', value: normalized.email },
    { label: 'Phone', value: normalized.phone },
    { label: 'Fax', value: normalized.fax },
    { label: 'Website', value: normalized.website },
    { label: 'Birthday', value: normalized.birthday },
    { label: 'Gender', value: normalized.gender },
    { label: 'Pronouns', value: normalized.pronouns },
    { label: 'Address', value: [normalized.address, normalized.address2, normalized.city, normalized.state, normalized.zip].filter(Boolean).join(', ') || null },
    { label: 'Notes', value: normalized.notes },
  ];
  return rows.filter((row) => row.value);
};

/** False when there is neither an email nor a phone to reach the contact by. */
export const hasContactMethod = (contact: ContactDetailsRecord): boolean => {
  const { email, phone } = normalizeContactDetails(contact);
  return !!(email || phone);
};
